interface MetadataItem {
  title: string
  description: string
}

interface Metadata {
  [locale: string]: {
    [page: string]: MetadataItem
  }
}

export const metadata: Metadata = {
  en: {
    home: {
      title:
        "Crypto.com International: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com International",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with 20+ fiat currencies. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  es: {
    home: {
      title:
        "Crypto.com Internacional: Compra, vende y opera de forma segura Bitcoin, Ethereum y más de 400 criptomonedas",
      description:
        "Compra, vende, guarda y opera más de 400 criptomonedas en Crypto.com, una plataforma de intercambio de criptomonedas segura y de confianza.",
    },
    app: {
      title:
        "App Crypto.com: Descarga la mejor app para BTC, ETH, CRO - Crypto.com Internacional",
      description:
        "Compra Bitcoin y más de 400 criptomonedas con más de 20 monedas fiat. Descarga la app de Crypto.com hoy para operar con tarifas bajas y máxima seguridad.",
    },
  },
  fr: {
    home: {
      title:
        "Crypto.com International : Achetez du Bitcoin, de l'Ethereum et 400+ cryptomonnaies",
      description:
        "Achetez, vendez, stockez et échangez plus de 400 cryptomonnaies sur Crypto.com, une plateforme sécurisée et fiable en France.",
    },
    app: {
      title:
        "Application Crypto.com : Téléchargez la meilleure app BTC, ETH, CRO - Crypto.com International",
      description:
        "Achetez du Bitcoin et plus de 400 cryptomonnaies avec plus de 20 devises fiat. Téléchargez l’app Crypto.com dès aujourd’hui pour des frais réduits et un trading sécurisé.",
    },
  },
  zh: {
    home: {
      title:
        "Crypto.com：安全地購買、出售及交易比特幣、以太坊等400多種加密貨幣",
      description:
        "Crypto.com 中國：安全地購買、出售和交易比特幣、以太坊及400多種加密貨幣，在中國。",
    },
    app: {
      title: "Crypto.com 應用程式：下載最佳 BTC、ETH、CRO 應用 - Crypto.com",
      description:
        "使用 20 多種法定貨幣購買比特幣和超過 400 種加密貨幣。立即下載 Crypto.com 應用程式，享受低手續費與安全交易。",
    },
  },
  id: {
    home: {
      title:
        "Crypto.com Indonesia: Beli, Jual, dan Perdagangkan Bitcoin, Ethereum, serta 400+ Kripto dengan Aman",
      description:
        "Beli, jual, simpan, dan tukar lebih dari 400+ cryptocurrency di Crypto.com, platform kripto yang aman dan terpercaya di Indonesia.",
    },
    app: {
      title:
        "Aplikasi Crypto.com: Unduh Aplikasi BTC, ETH, CRO Terbaik - Crypto.com Indonesia",
      description:
        "Beli Bitcoin dan lebih dari 400 aset kripto dengan Rupiah (IDR). Unduh aplikasi Crypto.com sekarang untuk biaya rendah dan transaksi aman.",
    },
  },
  vi: {
    home: {
      title:
        "Crypto.com Việt Nam: Mua, Bán và Giao dịch Bitcoin, Ethereum và hơn 400 loại Tiền điện tử một cách An toàn",
      description:
        "Mua, bán, lưu trữ và giao dịch hơn 400+ loại tiền điện tử trên Crypto.com, nền tảng giao dịch an toàn và đáng tin cậy tại Việt Nam.",
    },
    app: {
      title:
        "Ứng dụng Crypto.com: Tải ứng dụng BTC, ETH, CRO tốt nhất - Crypto.com Vietnam",
      description:
        "Mua Bitcoin và hơn 400 loại tiền điện tử bằng Đồng Việt Nam (VND). Tải ứng dụng Crypto.com ngay hôm nay để giao dịch an toàn và phí thấp.",
    },
  },
  "es-us": {
    home: {
      title:
        "Crypto.com Estados Unidos: Compra, vende y opera de forma segura Bitcoin, Ethereum y más de 400 criptomonedas",
      description:
        "Compra, vende, guarda y opera más de 400 criptomonedas en Crypto.com, una plataforma de intercambio de criptomonedas segura y de confianza.",
    },
    app: {
      title:
        "App Crypto.com: Descarga la mejor app para BTC, ETH, CRO - Crypto.com Estados Unidos",
      description:
        "Compra Bitcoin y más de 400 criptomonedas con dólares estadounidenses (USD). Descarga la app de Crypto.com hoy con tarifas bajas y seguridad garantizada.",
    },
  },
  us: {
    home: {
      title:
        "Crypto.com: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in the US.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com US",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with USD. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  uk: {
    home: {
      title:
        "Crypto.com UK: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in the UK.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com UK",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with GBP. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  ca: {
    home: {
      title:
        "Crypto.com Canada: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Canada.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Canada",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with CAD. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  "fr-ca": {
    home: {
      title:
        "Crypto.com Canada : Achetez du Bitcoin, de l'Ethereum et 400+ cryptomonnaies",
      description:
        "Achetez, vendez, stockez et échangez plus de 400 cryptomonnaies sur Crypto.com, une plateforme sécurisée et fiable en Canada.",
    },
    app: {
      title:
        "Application Crypto.com : Téléchargez la meilleure app BTC, ETH, CRO - Crypto.com Canada",
      description:
        "Achetez du Bitcoin et plus de 400 cryptomonnaies avec des dollars canadiens (CAD). Téléchargez l’app Crypto.com dès aujourd’hui pour des frais réduits et un trading sécurisé.",
    },
  },
  au: {
    home: {
      title:
        "Crypto.com Australia: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Australia.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Australia",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with AUD. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  sg: {
    home: {
      title:
        "Crypto.com Singapore: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Singapore.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Singapore",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with SGD. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  ae: {
    home: {
      title:
        "الإمارات: اشتر، بع، وتاجر بالبيتكوين والإيثيريوم وأكثر من 400 عملة مشفرة بأمان Crypto.com",
      description:
        ".منصة تبادل آمنة وموثوقة في الإمارات العربية المتحدة ،Crypto.com اشتر وبع واحفظ وتداول أكثر من 400 عملة مشفرة على",
    },
    app: {
      title:
        "تطبيق Crypto.com: حمّل أفضل تطبيق لشراء BTC وETH وCRO - Crypto.com الإمارات",
      description:
        "اشترِ بيتكوين وأكثر من 400 عملة رقمية باستخدام الدرهم الإماراتي (AED). نزّل تطبيق Crypto.com اليوم لتداول آمن ورسوم منخفضة.",
    },
  },
  "en-ae": {
    home: {
      title:
        "Crypto.com UAE: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in the UAE.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com UAE",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with AED. Download the Crypto.com app today for secure trading, low fees, and fast local deposits.",
    },
  },
  "pt-br": {
    home: {
      title:
        "Crypto.com Brasil: Compre, venda e negocie com segurança Bitcoin, Ethereum e mais de 400 criptomoedas",
      description:
        "Compre, venda, armazene e negocie mais de 400+ criptomoedas na Crypto.com, uma plataforma de troca segura e confiável no Brasil.",
    },
    app: {
      title:
        "Aplicativo Crypto.com: Baixe o melhor app de BTC, ETH, CRO - Crypto.com Brasil",
      description:
        "Compre Bitcoin e mais de 400 criptomoedas com reais (BRL). Baixe o app Crypto.com agora e aproveite taxas baixas e negociações seguras.",
    },
  },
  "en-br": {
    home: {
      title:
        "Crypto.com Brazil: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Brazil.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Brazil",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with BRL. Download the Crypto.com app today for secure trading, competitive fees, and local payment options.",
    },
  },
  kr: {
    home: {
      title:
        "Crypto.com 한국: 비트코인, 이더리움 및 400개 이상의 암호화폐를 안전하게 구매, 판매, 거래하세요",
      description:
        "Crypto.com에서 400종 이상의 암호화폐를 안전하고 신뢰할 수 있는 거래소 플랫폼에서 사고, 팔고, 보관하고 거래하세요. 한국에서.",
    },
    app: {
      title:
        "Crypto.com 앱: 최고의 BTC, ETH, CRO 앱 다운로드 - Crypto.com 한국",
      description:
        "원화(KRW)로 비트코인과 400개 이상의 암호화폐를 구매하세요. 지금 Crypto.com 앱을 다운로드하고 안전하고 저렴하게 거래하세요.",
    },
  },
  "en-kr": {
    home: {
      title:
        "Crypto.com Korea: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Korea.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Korea",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with KRW. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  da: {
    home: {
      title:
        "Crypto.com Danmark: Køb, sælg og handl Bitcoin, Ethereum og over 400 kryptovalutaer sikkert",
      description:
        "Køb, sælg, opbevar og handl over 400+ kryptovalutaer på Crypto.com, en sikker og pålidelig handelsplatform i Danmark.",
    },
    app: {
      title:
        "Crypto.com App: Download den bedste BTC, ETH, CRO app - Crypto.com Danmark",
      description:
        "Køb Bitcoin og mere end 400 kryptovalutaer med EUR. Download Crypto.com appen i dag for lave gebyrer og sikker handel.",
    },
  },
  "es-es": {
    home: {
      title:
        "Crypto.com España: Compra, vende y opera de forma segura Bitcoin, Ethereum y más de 400 criptomonedas",
      description:
        "Compra, vende, guarda y opera más de 400 criptomonedas en Crypto.com, una plataforma de intercambio de criptomonedas segura y de confianza.",
    },
    app: {
      title:
        "App Crypto.com: Descarga la mejor app para BTC, ETH, CRO - Crypto.com España",
      description:
        "Compra Bitcoin y más de 400 criptomonedas con euros (EUR). Descarga la app de Crypto.com hoy con tarifas bajas y operaciones seguras.",
    },
  },
  "en-es": {
    home: {
      title:
        "Crypto.com Spain: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Spain.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Spain",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with EUR. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  "fr-fr": {
    home: {
      title:
        "Crypto.com France : Achetez du Bitcoin, de l'Ethereum et 400+ cryptomonnaies",
      description:
        "Achetez, vendez, stockez et échangez plus de 400 cryptomonnaies sur Crypto.com, une plateforme d'échange sécurisée et de confiance en France.",
    },
    app: {
      title:
        "Application Crypto.com : Téléchargez la meilleure app BTC, ETH, CRO - Crypto.com France",
      description:
        "Achetez du Bitcoin et plus de 400 cryptomonnaies avec des euros (EUR). Téléchargez l’app Crypto.com dès aujourd’hui pour des frais réduits et un trading sécurisé.",
    },
  },
  "en-fr": {
    home: {
      title:
        "Crypto.com France: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in France.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com France",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with EUR. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  de: {
    home: {
      title:
        "Crypto.com Deutschland: Bitcoin, Ethereum und 400+ Kryptowährungen sicher kaufen und handeln",
      description:
        "Kaufen, verkaufen, speichern und handeln Sie über 400 Kryptowährungen auf Crypto.com, einer sicheren und vertrauenswürdigen Krypto-Börse in Deutschland.",
    },
    app: {
      title:
        "Crypto.com App: Lade die beste BTC, ETH, CRO App herunter - Crypto.com Deutschland",
      description:
        "Kaufe Bitcoin und über 400 Kryptowährungen mit Euro (EUR). Lade die Crypto.com App jetzt herunter für sichere und günstige Trades.",
    },
  },
  "en-de": {
    home: {
      title:
        "Crypto.com Germany: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Germany.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Germany",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with EUR. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  it: {
    home: {
      title:
        "Crypto.com Italia: Acquisto e Trading Sicuro di Bitcoin e 400+ Criptovalute",
      description:
        "Acquista, vendi, conserva e scambia oltre 400 criptovalute su Crypto.com, una piattaforma di scambio sicura e affidabile in Italia.",
    },
    app: {
      title:
        "App Crypto.com: Scarica la migliore app per BTC, ETH, CRO - Crypto.com Italia",
      description:
        "Acquista Bitcoin e oltre 400 criptovalute in euro (EUR). Scarica ora l’app Crypto.com e fai trading con la massima sicurezza e a basse commissioni.",
    },
  },
  "en-it": {
    home: {
      title:
        "Crypto.com Italy: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Italy.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Italy",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with EUR. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  pl: {
    home: {
      title:
        "Crypto.com Polska: Bezpiecznie kup, sprzedaj i handluj Bitcoinem, Ethereum i ponad 400 kryptowalutami",
      description:
        "Kupuj, sprzedawaj, przechowuj i handluj ponad 400 kryptowalutami na Crypto.com - bezpiecznej i zaufanej platformie wymiany kryptowalut w Polsce.",
    },
    app: {
      title:
        "Aplikacja Crypto.com: Pobierz najlepszą aplikację BTC, ETH, CRO - Crypto.com Polska",
      description:
        "Kup Bitcoina i ponad 400 kryptowalut za euro (EUR). Pobierz aplikację Crypto.com już dziś, aby handlować bezpiecznie i tanio.",
    },
  },
  pt: {
    home: {
      title:
        "Crypto.com Portugal: Compre, venda e negocie com segurança Bitcoin, Ethereum e mais de 400 criptomoedas",
      description:
        "Compre, venda, armazene e negocie mais de 400+ criptomoedas na Crypto.com, uma plataforma de troca segura e confiável em Portugal.",
    },
    app: {
      title:
        "Aplicativo Crypto.com: Baixe o melhor app BTC, ETH, CRO - Crypto.com Portugal",
      description:
        "Compre Bitcoin e mais de 400 criptomoedas com euros (EUR). Baixe o app Crypto.com agora para taxas baixas e negociações seguras.",
    },
  },
  nl: {
    home: {
      title:
        "Crypto.com Nederland: Veilig Bitcoin, Ethereum en meer dan 400 cryptovaluta kopen, verkopen en verhandelen",
      description:
        "Koop, verkoop, bewaar en verhandel meer dan 400+ cryptovaluta op Crypto.com, een veilig en vertrouwd handelsplatform in Nederland.",
    },
    app: {
      title:
        "Crypto.com App: Download de beste BTC, ETH, CRO app - Crypto.com Nederland",
      description:
        "Koop Bitcoin en meer dan 400 cryptovaluta’s met euro (EUR). Download de Crypto.com app vandaag voor lage kosten en veilige handel.",
    },
  },
  "en-nl": {
    home: {
      title:
        "Crypto.com Netherlands: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in the Netherlands.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Netherlands",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with EUR. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  se: {
    home: {
      title:
        "Crypto.com Sverige: Köp och sälj Bitcoin, Ethereum och 400+ kryptovalutor på ett säkert sätt",
      description:
        "Köp, sälj, förvara och handla över 400 kryptovalutor på Crypto.com, en säker och pålitlig kryptobörs i Sverige.",
    },
    app: {
      title:
        "Crypto.com App: Ladda ner den bästa BTC, ETH, CRO appen - Crypto.com Sverige",
      description:
        "Köp Bitcoin och över 400 kryptovalutor med euro (EUR). Ladda ner Crypto.com appen idag för låga avgifter och säker handel.",
    },
  },
  no: {
    home: {
      title:
        "Crypto.com Norge: Kjøp, selg og handle Bitcoin, Ethereum og over 400 kryptovalutaer sikkert",
      description:
        "Kjøp, selg, oppbevar og handle over 400+ kryptovalutaer på Crypto.com, en trygg og pålitelig handelsplattform i Norge.",
    },
    app: {
      title:
        "Crypto.com App: Last ned den beste BTC, ETH, CRO appen - Crypto.com Norge",
      description:
        "Kjøp Bitcoin og over 400 kryptovalutaer med euro (EUR). Last ned Crypto.com appen nå for lave gebyrer og trygg handel.",
    },
  },
  "en-no": {
    home: {
      title:
        "Crypto.com Norway: Securely Buy, Sell and Trade Bitcoin, Ethereum and 400+ Crypto",
      description:
        "Buy, sell, store, and trade over 400+ cryptocurrencies on Crypto.com, a secure and trusted crypto exchange platform in Norway.",
    },
    app: {
      title:
        "Crypto.com App: Download the Best BTC, ETH, CRO App - Crypto.com Norway",
      description:
        "Buy Bitcoin and 400+ cryptocurrencies with EUR. Download the Crypto.com app today for low fees and secure trading.",
    },
  },
  el: {
    home: {
      title:
        "Crypto.com Ελλάδα: Αγοράστε & Πουλήστε Bitcoin, Ethereum και 400+ Κρυπτονομίσματα με Ασφάλεια",
      description:
        "Αγοράστε, πουλήστε, αποθηκεύστε και ανταλλάξτε 400+ κρυπτονομίσματα στο Crypto.com, μια ασφαλή και αξιόπιστη πλατφόρμα στην Ελλάδα.",
    },
    app: {
      title:
        "Εφαρμογή Crypto.com: Κατεβάστε την καλύτερη εφαρμογή BTC, ETH, CRO - Crypto.com Ελλάδα",
      description:
        "Αγοράστε Bitcoin και 400+ κρυπτονομίσματα με ευρώ (EUR). Κατεβάστε την εφαρμογή Crypto.com σήμερα για ασφαλείς συναλλαγές και χαμηλές χρεώσεις.",
    },
  },
  hr: {
    home: {
      title:
        "Crypto.com Hrvatska: Sigurno kupujte, prodajte i trgujte Bitcoinom, Ethereumom i više od 400 kriptovaluta",
      description:
        "Kupujte, prodajte, pohranite i trgujte s više od 400 kriptovaluta na Crypto.com, sigurnoj i pouzdanoj kripto burzi u Hrvatskoj.",
    },
    app: {
      title:
        "Crypto.com App: Preuzmite najbolju BTC, ETH, CRO aplikaciju - Crypto.com Hrvatska",
      description:
        "Kupite Bitcoin i više od 400 kriptovaluta u eurima (EUR). Preuzmite aplikaciju Crypto.com već danas za sigurno trgovanje i niske naknade.",
    },
  },
  ro: {
    home: {
      title:
        "Crypto.com România: Cumpără, vinde și tranzacționează Bitcoin, Ethereum și peste 400 de criptomonede în siguranță",
      description:
        "Cumpără, vinde, stochează și tranzacționează peste 400+ criptomonede pe Crypto.com, o platformă de schimb sigură și de încredere în România.",
    },
    app: {
      title:
        "Aplicația Crypto.com: Descarcă cea mai bună aplicație BTC, ETH, CRO - Crypto.com România",
      description:
        "Cumpără Bitcoin și peste 400 de criptomonede în euro (EUR). Descarcă aplicația Crypto.com acum pentru comisioane mici și tranzacții sigure.",
    },
  },
}
